import React, { useState } from 'react';
import { useLocale } from '../../localization/LocaleContext';

/**
 * Renders one FAQ category as an accessible accordion.
 * @param {string} id - anchor id used for quick-nav / deep links (e.g. "invoices")
 * @param {string} translationKey - base translation key under `faq.*` (e.g. "invoices")
 * @param {string[]} questionKeys - list of q/a index suffixes, e.g. ['1','2','3']
 * @param {string[]} icon - optional emoji/icon shown next to the heading
 */
export default function FAQCategory({ id, translationKey, questionKeys, icon }) {
    const { t } = useLocale();
    const [openIndex, setOpenIndex] = useState(0);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="faq-category" id={id}>
            <h2 className="faq-category-heading">
                {icon && <span className="faq-category-icon" aria-hidden="true">{icon}</span>}
                {t(`faq.${translationKey}.heading`)}
            </h2>
            <div className="faq-accordion-list">
                {questionKeys.map((num, index) => {
                    const question = t(`faq.${translationKey}.q${num}`);
                    const answer = t(`faq.${translationKey}.a${num}`);
                    const isOpen = openIndex === index;
                    return (
                        <div
                            className={`faq-accordion-item${isOpen ? ' faq-accordion-item--open' : ''}`}
                            key={num}
                        >
                            <button
                                className="faq-accordion-question"
                                onClick={() => toggle(index)}
                                aria-expanded={isOpen}
                            >
                                <span>{question}</span>
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="faq-accordion-chevron"
                                >
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </button>
                            <div className="faq-accordion-answer">
                                <p>{answer}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
